import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./InfoComponent.module.css";
import { useTranslation } from "@i18n";
import Input from "@/components/UiKit/Input/Input";
import { useState } from "react";
import Select from "@/components/UiKit/Select/Select";
import { api__getCitiesDropDown } from "@/apis/assets/api__get_cities_drop_down";
import { CDN_LINK } from "@globalConfig";
import RadioButtonMD from "./RadioButtonMD";
import ChangeAccountVerificationModal from "@/_MiniApps/auth/ui/ChangeAccountVerificationModal/ChangeAccountVerificationModal";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useHelpers from "@hooks/useHelpers";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import RequiredDocuments from "@/pages/checkout/arib-finance/component/RequiredDocuments";
import DateCalendarGregorian from "@componentsShared/DateCalendarGregorian/DateCalendarGregorian";
import { fromDateStrToObject } from "@componentsShared/DateCalendarGregorian/DateCalendarHelpers";
var AribInfoComponent = function AribInfoComponent(_ref) {
  var setIsOtpStep = _ref.setIsOtpStep,
    warrantyId = _ref.warrantyId;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var post_id = useAribFinance().queryParams.post_id;
  var _useSession = useSession(),
    user = _useSession.user;
  var _useAuthActions = useAuthActions(),
    logout = _useAuthActions.logout;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    createUrl = _useHelpers.createUrl;
  var userInfo = useAribFinance().state.userInfo;
  var orderData = useAribFinance().state.orderData;
  var postData = useAribFinance().state.postData;
  var fetch_loading = useAribFinance().state.fetch_loading;
  var _useAribFinance = useAribFinance(),
    aribActions = _useAribFinance.actions;
  var fetch__createAribOrder = useAribFinance().remote_actions.fetch__createAribOrder;
  var helper__getAribPaymentType = useAribFinance().helpers.helper__getAribPaymentType;
  var _useState = useState(false),
    showVerificationModal = _useState[0],
    setShowVerificationModal = _useState[1];
  var _useApi = useApi([], api__getCitiesDropDown),
    _useApi2 = _slicedToArray(_useApi, 3),
    loadingCities = _useApi2[0],
    error = _useApi2[1],
    cities = _useApi2[2];
  var _useState2 = useState({}),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState(null),
    formValidationException = _useState3[0],
    setFormValidationException = _useState3[1];
  var step2Url = createUrl("/finance-apply-arib", {
    post_id: post_id,
    financestep: 2
  });
  var brithDateValue = !(userInfo !== null && userInfo !== void 0 && userInfo.birth_date) ? null : _objectSpread(_objectSpread({}, fromDateStrToObject(userInfo === null || userInfo === void 0 ? void 0 : userInfo.birth_date, userInfo === null || userInfo === void 0 ? void 0 : userInfo.birth_date_calendar_type)), {}, {
    type: userInfo === null || userInfo === void 0 ? void 0 : userInfo.birth_date_calendar_type
  });
  var updateErrors = function updateErrors(key, value) {
    setErrors(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
    });
  };
  var updateData = function updateData(key, value) {
    aribActions === null || aribActions === void 0 ? void 0 : aribActions.action__updateUserInfo(_defineProperty({}, key, value));
  };
  var updateAllData = function updateAllData(newData) {
    aribActions === null || aribActions === void 0 ? void 0 : aribActions.action__updateUserInfo(newData);
  };

  // New validate function using the same keys as the inputs with updated conditions
  var validate = function validate() {
    var isValid = true;
    var newErrors = {};

    // Validate first_name
    if (!userInfo["first_name"] || userInfo["first_name"].trim() === "") {
      newErrors["first_name"] = tShort("arib/first_name_required", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    } else if (userInfo["first_name"].trim().length < 2) {
      newErrors["first_name"] = tShort("arib/first_name_min_length", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    }

    // Validate fathers_name
    if (!userInfo["fathers_name"] || userInfo["fathers_name"].trim() === "") {
      newErrors["fathers_name"] = tShort("arib/fathers_name_required", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    } else if (userInfo["fathers_name"].trim().length < 2) {
      newErrors["fathers_name"] = tShort("arib/fathers_name_min_length", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    }

    // Validate family_name
    if (!userInfo["family_name"] || userInfo["family_name"].trim() === "") {
      newErrors["family_name"] = tShort("arib/family_name_required", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    } else if (userInfo["family_name"].trim().length < 2) {
      newErrors["family_name"] = tShort("arib/family_name_min_length", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    }

    // Validate gender
    if (!userInfo["gender"]) {
      newErrors["gender"] = tShort("arib/gender_required", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    }

    // Validate id_number
    if (!userInfo["id_number"] || userInfo["id_number"].trim() === "") {
      newErrors["id_number"] = tShort("arib/id_number_required", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    } else if (!/^[127]\d{9}$/.test(userInfo["id_number"])) {
      newErrors["id_number"] = tShort("arib/id_number_invalid_format", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    }

    // Validate mobile_number
    if (!userInfo["mobile_number"] || userInfo["mobile_number"].trim() === "") {
      newErrors["mobile_number"] = tShort("arib/mobile_required", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    } else if (!/^05\d{8}$/.test(userInfo["mobile_number"])) {
      newErrors["mobile_number"] = tShort("arib/mobile_invalid_format", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    }

    // Validate city_id
    if (!userInfo["city_id"]) {
      newErrors["city_id"] = tShort("arib/city_required", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    }

    // Validate birth_date - check if date is empty or incomplete
    if (!userInfo["birth_date"] || userInfo["birth_date"].trim() === "") {
      newErrors["birth_date"] = tShort("arib/birth_date_required", {
        ns: "web_checkout_finance"
      });
      isValid = false;
    } else {
      // Check if the date has all required parts (day, month, year)
      var dateParts = userInfo["birth_date"].split('-');
      if (dateParts.length !== 3 || dateParts.some(function (part) {
        return !part || part === "null" || part === "undefined";
      })) {
        newErrors["birth_date"] = tShort("arib/enter_valid_birthdate", {
          ns: "web_checkout_finance"
        });
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };
  var sendData = function sendData() {
    // Use the new validate function which checks all related fields
    if (!validate()) {
      return;
    }
    if (userInfo["mobile_number"] != null && user !== null && user !== void 0 && user.phone_number && (user === null || user === void 0 ? void 0 : user.phone_number) != userInfo["mobile_number"] && !showVerificationModal) {
      return setShowVerificationModal(true);
    }

    // Warranty is per-car, not per-user — keep it out of userInfo/arib_userInfo.
    aribActions === null || aribActions === void 0 ? void 0 : aribActions.action__setWarrantyId(warrantyId !== null && warrantyId !== void 0 ? warrantyId : null);
    var financeData = sessionStorage.getItem("installment-calculator-".concat(post_id));
    var submitData = {};
    if (financeData) {
      var parsedData = JSON.parse(financeData);
      submitData.first_payment = parsedData === null || parsedData === void 0 ? void 0 : parsedData.down_payment;
      submitData.monthly_installment = parsedData === null || parsedData === void 0 ? void 0 : parsedData.monthly_installment;
      submitData.installment_period = parsedData === null || parsedData === void 0 ? void 0 : parsedData.period;
      submitData.last_payment = parsedData === null || parsedData === void 0 ? void 0 : parsedData.last_payment;
    }
    if (Object.keys(submitData).length > 0) {
      updateAllData(submitData);
    }
    setIsOtpStep(true);
  };
  if (loadingCities) return /*#__PURE__*/React.createElement(Loader, null);
  var requiredFields = ["first_name", "fathers_name", "family_name", "mobile_number", "city_id", "gender", "id_number", "birth_date"];
  var isButtonDisabled = requiredFields.some(function (field) {
    var value = userInfo[field];
    if (field === "birth_date") {
      // Special validation for birth_date to check for incomplete dates
      if (!value || value.trim() === "") return true;
      var dateParts = value.split('-');
      return dateParts.length !== 3 || dateParts.some(function (part) {
        return !part || part === "null" || part === "undefined";
      });
    }
    return value === null || value === undefined || value === "";
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "arib-form-container",
    className: "mt-8 relative"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
    id: "checkout-firstname-input",
    className: "mb-[34px]",
    name: "first_name",
    label: t("first_name", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.first_name : "",
    onChange: function onChange(event) {
      updateData("first_name", event.currentTarget.value);
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.first_name) && updateErrors("first_name", "");
    },
    value: userInfo === null || userInfo === void 0 ? void 0 : userInfo.first_name
  }), /*#__PURE__*/React.createElement(Input, {
    id: "arib-fathersname-input",
    className: "mb-[34px]",
    name: "fathers_name",
    label: t("middle_name", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.fathers_name : "",
    onChange: function onChange(event) {
      updateData("fathers_name", event.currentTarget.value);
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.fathers_name) && updateErrors("fathers_name", "");
    },
    value: userInfo === null || userInfo === void 0 ? void 0 : userInfo.fathers_name
  }), /*#__PURE__*/React.createElement(Input, {
    id: "checkout-lastname-input",
    className: "mb-[34px]",
    name: "family_name",
    label: t("last_name", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.family_name : "",
    onChange: function onChange(event) {
      updateData("family_name", event.currentTarget.value);
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.family_name) && updateErrors("family_name", "");
    },
    value: userInfo === null || userInfo === void 0 ? void 0 : userInfo.family_name
  }), /*#__PURE__*/React.createElement(RadioButtonMD, {
    selected: userInfo["gender"],
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.gender : "",
    className: "mb-[34px]",
    onChange: function onChange(event) {
      (errors === null || errors === void 0 ? void 0 : errors.gender) && updateErrors("gender", "");
      updateData("gender", event.currentTarget.value);
    },
    label: t("gender", {
      ns: "web_checkout_finance"
    }),
    name: "name",
    options: [{
      title: t("male", {
        ns: "web_checkout_finance"
      }),
      value: "10"
    }, {
      title: t("female", {
        ns: "web_checkout_finance"
      }),
      value: "20"
    }]
  }), /*#__PURE__*/React.createElement("div", {
    className: "mb-[34px] pt-[34px] pb-[34px] border-solid border-t-[1px] border-t-dashed border-b-[1px] border-b-solid border-[#EBF0F7]"
  }, /*#__PURE__*/React.createElement(DateCalendarGregorian, {
    label: t("birth_date", {
      ns: "web_checkout_finance"
    }),
    value: brithDateValue,
    errorMessage: errors ? errors === null || errors === void 0 ? void 0 : errors.birth_date : "",
    yearsFrom: -80,
    yearsTo: -16,
    onChange: function onChange(newValue) {
      if (errors !== null && errors !== void 0 && errors.birth_date) {
        updateErrors("birth_date", "");
      }
      var dateStr = newValue ? "".concat(newValue.year, "-").concat(newValue.month, "-").concat(newValue.day || "1") : "";
      updateData("birth_date", dateStr);
      updateData("birth_date_calendar_type", (newValue === null || newValue === void 0 ? void 0 : newValue.type) || "G");
    }
  })), /*#__PURE__*/React.createElement(Input, {
    id: "arib-idnumber-input",
    className: "mb-[34px]",
    maxLength: 10,
    name: "id_number",
    label: t("identification_number", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    inputMode: "numeric",
    onlyNumbers: true,
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.id_number : "",
    onChange: function onChange(event) {
      updateData("id_number", event.currentTarget.value);
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.id_number) && updateErrors("id_number", "");
    },
    value: userInfo["id_number"]
  }), /*#__PURE__*/React.createElement(InputPhoneNumber, {
    id: "checkout-phone-input",
    className: "mb-[34px]",
    defaultValue: userInfo["mobile_number"],
    onChange: function onChange(value) {
      updateData("mobile_number", value);
    },
    errorLabel: errors ? errors === null || errors === void 0 ? void 0 : errors.mobile_number : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.seller_mobile) && updateErrors("seller_mobile", "");
    }
  }), /*#__PURE__*/React.createElement("label", {
    id: "arib-whatsapp-label",
    className: [stl.whtsFlx, "mb-[34px]"].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    id: "arib-whatsapp-input",
    onChange: function onChange(_) {
      var new_value = userInfo["whatsapp_optin"] ? 0 : 1;
      updateData("whatsapp_optin", new_value);
    },
    defaultChecked: !!userInfo["whatsapp_optin"],
    type: "checkbox",
    name: "whatsapp_optin"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.boxDummy
  }), /*#__PURE__*/React.createElement("img", {
    id: "arib-whatsapp-icon",
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "whts",
    width: "24px",
    height: "24px"
  }), /*#__PURE__*/React.createElement("span", {
    id: "arib-whatsapp-text"
  }, t("like_receive_updates_order_via", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement(Select, {
    id: "checkout-city-select",
    name: "city_id",
    topLabel: t("city", {
      ns: "web_checkout_finance"
    }),
    type: "select",
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.city_id : "",
    onChange: function onChange(event) {
      updateData("city_id", event.currentTarget.value);
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.city_id) && updateErrors("city_id", "");
    }
  }, cities.map(function (city, idx) {
    return idx === 0 ? /*#__PURE__*/React.createElement("option", {
      disabled: true,
      selected: true,
      hidden: true,
      key: idx
    }, t("select", {
      ns: "web_checkout_finance"
    })) : /*#__PURE__*/React.createElement("option", {
      selected: userInfo["city_id"] == city.id,
      key: city.id,
      value: city.id
    }, city.name);
  })), /*#__PURE__*/React.createElement(RequiredDocuments, {
    className: "m-show",
    blueStyle: false
  }), /*#__PURE__*/React.createElement("div", {
    id: "arib-submit-wrapper",
    className: stl.submitData
  }, /*#__PURE__*/React.createElement("button", {
    id: "checkout-submit-btn"
    // isButtonDisabled ? "!bg-gray-500 opacity-50 text-white" :
    ,
    className: ["blueBtn"].join(" "),
    onClick: sendData,
    disabled: fetch_loading
  }, /*#__PURE__*/React.createElement("strong", null, t("next_step", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", null))), /*#__PURE__*/React.createElement(ChangeAccountVerificationModal, {
    show: showVerificationModal,
    onClose: function onClose() {
      return setShowVerificationModal(false);
    },
    onSubmit: function onSubmit() {
      setShowVerificationModal(false);
      logout(null).then(function () {
        return setIsOtpStep(true);
      });
    },
    newPhoneNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobile_number
  }))));
};
export default AribInfoComponent;